import { createSlice } from "@reduxjs/toolkit";
import {
  AddAccessManagementUsers,
  DeleteAccessManagementUsers,
  EditAccessManagementUsers,
  GetAllAccessManagementUsers,
  ChangePasswordAccessManagementUsers,
} from "store/middlewares/membersAndRoles/teamMembers";

export const accessUsersSlice = createSlice({
  name: "accessUsers",
  initialState: {
    accessUsersLoading: true,
    accessUsers: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      // For get all access management users
      .addCase(GetAllAccessManagementUsers.pending, (state) => {
        // state.accessUsersLoading = true;
        // state.accessUsers = null;
        state.accessUsers =
          state.accessUsers?.data?.length > 0 ? state.accessUsers : null;
      })
      .addCase(GetAllAccessManagementUsers.fulfilled, (state, action) => {
        state.accessUsersLoading = false;
        state.accessUsers = action.payload.response;
      })
      .addCase(GetAllAccessManagementUsers.rejected, (state) => {
        state.accessUsersLoading = false;
        state.accessUsers = null;
      })

      // For add new access management user
      .addCase(AddAccessManagementUsers.fulfilled, (state, action) => {
        state.accessUsersLoading = false;
        state.accessUsers = {
          ...state.accessUsers,
          total: Number(state.accessUsers.total) + 1,
          data: [action.payload.response, ...state.accessUsers.data],
        };
      })

      // For add new access management user
      .addCase(DeleteAccessManagementUsers.fulfilled, (state, action) => {
        // state.accessUsersLoading = false;
        // state.accessUsers = {
        //   ...state.accessUsers,
        //   total: Number(state.accessUsers.total) - 1,
        //   data: state.accessUsers?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.accessUsersLoading = false;
        state.accessUsers = action.payload.response;
      })

      // For edit access management user
      .addCase(EditAccessManagementUsers.fulfilled, (state, action) => {
        state.accessUsersLoading = false;
        state.accessUsers = {
          ...state.accessUsers,
          data: state.accessUsers.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //For Update Password
      .addCase(
        ChangePasswordAccessManagementUsers.fulfilled,
        (state, action) => {
          state.accessUsersLoading = false;
          state.accessUsers = {
            ...state.accessUsers,
            data: state.accessUsers.data.map((item) =>
              item.id === action.payload.response
                ? action.payload.response
                : item
            ),
          };
        }
      );
  },
});

export default accessUsersSlice.reducer;
